/**
 * This context is used to store the state of the opening which is currently stored in the the zustand store
 * But this is a global state and we want to use it in the opening page alone
 * Eventually everything from the zustand store will be moved to this context
 */

import {
  SourcingHiringGoal,
  SourcingOpeningDetailAnalyticsData,
} from 'api-clients/monolith';
import { createContext, useContext, useState } from 'react';

type OpeningContextType = {
  showAggregateData: boolean;
  setShowAggregateData: (showAggregateData: boolean) => void;
  analyticsData?: SourcingOpeningDetailAnalyticsData;
  setAnalyticsData: (analytics: SourcingOpeningDetailAnalyticsData) => void;
  showCheckbox: boolean;
  setShowCheckbox: (showCheckbox: boolean) => void;
  hiringGoal?: SourcingHiringGoal;
  setHiringGoal: (hiringGoal: SourcingHiringGoal) => void;
};

export const OpeningContext = createContext<OpeningContextType | undefined>(
  undefined,
);

export function OpeningProvider({ children }: { children: React.ReactNode }) {
  const [showAggregateData, setShowAggregateData] = useState(true);
  const [analyticsData, setAnalyticsData] =
    useState<SourcingOpeningDetailAnalyticsData>();
  const [showCheckbox, setShowCheckbox] = useState(false);
  const [hiringGoal, setHiringGoal] = useState<SourcingHiringGoal>();

  return (
    <OpeningContext.Provider
      value={{
        showAggregateData,
        setShowAggregateData,
        analyticsData,
        setAnalyticsData,
        showCheckbox,
        setShowCheckbox,
        hiringGoal,
        setHiringGoal,
      }}
    >
      {children}
    </OpeningContext.Provider>
  );
}

export function useOpeningContext() {
  const context = useContext(OpeningContext);

  if (!context) {
    throw new Error('useOpeningContext must be used within an OpeningProvider');
  }

  return context;
}
